import { resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9aa098ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block container-box" }
const _hoisted_2 = { class: "from" }
const _hoisted_3 = { class: "from-item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "from-item-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "important" }, "*"),
  /*#__PURE__*/_createTextVNode(" 选择出险人： ")
], -1))
const _hoisted_5 = { class: "from-item-right" }
const _hoisted_6 = { class: "name-list" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-user" }, null, -1))
const _hoisted_8 = { class: "from-item alone" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "from-item-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "important" }, "*"),
  /*#__PURE__*/_createTextVNode(" 出险人电话： ")
], -1))
const _hoisted_10 = { class: "from-item-right" }
const _hoisted_11 = { class: "from-item alone" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "from-item-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "important" }, "*"),
  /*#__PURE__*/_createTextVNode(" 出险时间： ")
], -1))
const _hoisted_13 = { class: "from-item-right" }
const _hoisted_14 = { class: "from-item alone" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "from-item-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "important" }, "*"),
  /*#__PURE__*/_createTextVNode(" 事故类型： ")
], -1))
const _hoisted_16 = { class: "from-item-right" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("工伤")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 工伤")
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"width":"244px","color":"#646A73"} }, [
  /*#__PURE__*/_createTextVNode(" （一）在工作时间和工作场所内，因工作原因受到事故伤害的；"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" （二）在上下班途中，受到非本人主要责任的交通事故或者城市轨道交通、客运轮渡、火车事故伤害的。 ")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-info tisp-info",
  style: {"color":"#2EA1FF"}
}, null, -1))
const _hoisted_22 = /*#__PURE__*/_createTextVNode("意外")
const _hoisted_23 = { class: "from-item alone" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "from-item-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "important" }, "*"),
  /*#__PURE__*/_createTextVNode(" 是否骨折： ")
], -1))
const _hoisted_25 = { class: "from-item-right" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_28 = { class: "from-item alone" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "from-item-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "important" }, "*"),
  /*#__PURE__*/_createTextVNode(" 是否住院： ")
], -1))
const _hoisted_30 = { class: "from-item-right" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_33 = { class: "from-item" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "from-item-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "important" }, "*"),
  /*#__PURE__*/_createTextVNode(" 出险省市区： ")
], -1))
const _hoisted_35 = { class: "from-item-right" }
const _hoisted_36 = { class: "from-item" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "from-item-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "important" }, "*"),
  /*#__PURE__*/_createTextVNode(" 出险具体地址： ")
], -1))
const _hoisted_38 = { class: "from-item-right" }
const _hoisted_39 = { class: "from-item alone" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "from-item-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "important" }, "*"),
  /*#__PURE__*/_createTextVNode(" 就诊医院： ")
], -1))
const _hoisted_41 = { class: "from-item-right" }
const _hoisted_42 = {
  key: 0,
  class: "from-item alone"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "from-item-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "important" }, "*"),
  /*#__PURE__*/_createTextVNode(" 医院是否公立二级以上： ")
], -1))
const _hoisted_44 = { class: "from-item-right" }
const _hoisted_45 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_46 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_47 = {
  key: 1,
  class: "from-item alone"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "from-item-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "important" }, "*"),
  /*#__PURE__*/_createTextVNode(" 诊断结果： ")
], -1))
const _hoisted_49 = { class: "from-item-right" }
const _hoisted_50 = {
  key: 2,
  class: "from-item alone"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "from-item-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "important" }, "*"),
  /*#__PURE__*/_createTextVNode(" 预估金额： ")
], -1))
const _hoisted_52 = { class: "from-item-right" }
const _hoisted_53 = { class: "from-item" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "from-item-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "important" }, "*"),
  /*#__PURE__*/_createTextVNode(" 详细事故经过： ")
], -1))
const _hoisted_55 = { class: "from-item-right" }
const _hoisted_56 = { class: "from-item" }
const _hoisted_57 = { class: "from-item-left" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "important" }, "*", -1))
const _hoisted_59 = { class: "from-item-right" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "mini-btn" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "el-icon el-icon-plus" }),
  /*#__PURE__*/_createTextVNode(" 上传图片/视频 ")
], -1))
const _hoisted_61 = { class: "from-item-left" }
const _hoisted_62 = {
  key: 0,
  class: "important"
}
const _hoisted_63 = { class: "from-item-right" }
const _hoisted_64 = {
  key: 0,
  class: "mini-btn"
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon el-icon-plus" }, null, -1))
const _hoisted_66 = /*#__PURE__*/_createTextVNode(" 上传图片/视频 ")
const _hoisted_67 = [
  _hoisted_65,
  _hoisted_66
]
const _hoisted_68 = {
  key: 0,
  style: {"color":"#8691A3","font-size":"12px","margin-top":"4px"}
}
const _hoisted_69 = { class: "from-item alone" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "from-item-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "important" }, "*"),
  /*#__PURE__*/_createTextVNode(" 报案人电话： ")
], -1))
const _hoisted_71 = { class: "from-item-right" }
const _hoisted_72 = { class: "from-item alone-btn" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_head = _resolveComponent("page-head")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_AreaSelector = _resolveComponent("AreaSelector")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_select_personnel = _resolveComponent("select-personnel")!
  const _component_el_image_viewer = _resolveComponent("el-image-viewer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_page_head, { title: "新增报案" }, {
      left: _withCtx(() => []),
      right: _withCtx(() => []),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "btn",
              style: {"width":"102px","height":"32px"},
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.isEject && _ctx.isEject(...args)))
            }, " 选择出险人 "),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selection, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "name-i",
                  key: index
                }, [
                  _hoisted_7,
                  _createTextVNode(" " + _toDisplayString(item.name), 1)
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.info.employeePhone,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.info.employeePhone) = $event)),
              type: "text",
              style: {"width":"310px"},
              placeholder: "请输入出险员工真实电话"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_el_date_picker, {
              modelValue: _ctx.info.caseDate,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.info.caseDate) = $event)),
              type: "datetime",
              placeholder: "选择出险时间",
              style: {"width":"310px"},
              format: "YYYY-MM-DD HH:mm:ss",
              "value-format": "YYYY-MM-DD HH:mm:ss"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_el_radio, {
              modelValue: _ctx.info.type,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.info.type) = $event)),
              label: "10"
            }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_tooltip, {
              class: "item",
              effect: "light",
              placement: "bottom-start"
            }, {
              content: _withCtx(() => [
                _hoisted_18,
                _hoisted_19,
                _hoisted_20
              ]),
              default: _withCtx(() => [
                _hoisted_21
              ]),
              _: 1
            }),
            _createVNode(_component_el_radio, {
              modelValue: _ctx.info.type,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.info.type) = $event)),
              label: "20"
            }, {
              default: _withCtx(() => [
                _hoisted_22
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_el_radio, {
              modelValue: _ctx.info.is_serious,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.info.is_serious) = $event)),
              label: "1"
            }, {
              default: _withCtx(() => [
                _hoisted_26
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_radio, {
              style: {"margin-left":"20px"},
              modelValue: _ctx.info.is_serious,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.info.is_serious) = $event)),
              label: "0"
            }, {
              default: _withCtx(() => [
                _hoisted_27
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_component_el_radio, {
              modelValue: _ctx.info.is_hospital,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.info.is_hospital) = $event)),
              label: "1"
            }, {
              default: _withCtx(() => [
                _hoisted_31
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_radio, {
              style: {"margin-left":"20px"},
              modelValue: _ctx.info.is_hospital,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.info.is_hospital) = $event)),
              label: "0"
            }, {
              default: _withCtx(() => [
                _hoisted_32
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _createElementVNode("div", _hoisted_35, [
            _createVNode(_component_AreaSelector, {
              modelValue: _ctx.info.area.full_name,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.info.area.full_name) = $event)),
              onChange: _ctx.handleAreaChange
            }, null, 8, ["modelValue", "onChange"])
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _hoisted_37,
          _createElementVNode("div", _hoisted_38, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.info.address,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.info.address) = $event)),
              type: "textarea",
              style: {"width":"384px"},
              placeholder: "示例：新星南路155号"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_39, [
          _hoisted_40,
          _createElementVNode("div", _hoisted_41, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.info.hospital,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.info.hospital) = $event)),
              type: "text",
              style: {"width":"384px"},
              placeholder: "示例：昆山市第一人民医院"
            }, null, 8, ["modelValue"])
          ])
        ]),
        (_ctx.hasAppFeature('publicGrade2Hospital') && _ctx.info.hospital)
          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
              _hoisted_43,
              _createElementVNode("div", _hoisted_44, [
                _createVNode(_component_el_radio, {
                  modelValue: _ctx.info.is_public_grade2,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.info.is_public_grade2) = $event)),
                  label: "1"
                }, {
                  default: _withCtx(() => [
                    _hoisted_45
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_radio, {
                  style: {"margin-left":"20px"},
                  modelValue: _ctx.info.is_public_grade2,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.info.is_public_grade2) = $event)),
                  label: "0",
                  onChange: _ctx.onPublicGrade2Change
                }, {
                  default: _withCtx(() => [
                    _hoisted_46
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.hasAppFeature('lgdCaseExtra'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
              _hoisted_48,
              _createElementVNode("div", _hoisted_49, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.info.disorder,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.info.disorder) = $event)),
                  type: "text",
                  style: {"width":"384px"},
                  placeholder: "示例：左手臂轻微擦伤"
                }, null, 8, ["modelValue"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.hasAppFeature('lgdCaseExtra'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
              _hoisted_51,
              _createElementVNode("div", _hoisted_52, [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.info.client_estimate_money,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.info.client_estimate_money) = $event)),
                  placeholder: "选择预估金额",
                  size: "large",
                  style: {"width":"240px"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.client_estimate_money_list, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item,
                        value: item
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_53, [
          _hoisted_54,
          _createElementVNode("div", _hoisted_55, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.info.desc,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.info.desc) = $event)),
              type: "textarea",
              style: {"width":"384px"},
              rows: "8",
              placeholder: "示例：2020年2月1日18时05分，张三在XX机械A区车间操作机床时，右手不慎被模具压伤，拇指、食指外伤。在车间组长李四陪同下到厂区医务室处理。18∶15我司驻场王五赶到现场，驾驶私人轿车大众朗逸前往昆山第一人民医院就诊。18∶35 到达昆山第一人民医院，经医院拍片诊断，右手拇指、食指骨折，现已手术住院治疗，目前我司预交一万五千元。"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("div", _hoisted_57, [
            _hoisted_58,
            _createTextVNode(" " + _toDisplayString(_ctx.uploadTitle) + "： ", 1)
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createVNode(_component_el_upload, {
              name: "iFile",
              headers: { 'Access-Token': _ctx.token },
              "file-list": _ctx.files,
              action: "",
              "before-upload": _ctx.fileLimit,
              "http-request": _ctx.fileUpload,
              onPreview: _ctx.filePreview,
              onRemove: _ctx.fileRemove
            }, {
              default: _withCtx(() => [
                _hoisted_60
              ]),
              _: 1
            }, 8, ["headers", "file-list", "before-upload", "http-request", "onPreview", "onRemove"])
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bilConfigList, (configItem, cIndex) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "from-item",
            key: 'bil-' + cIndex
          }, [
            _createElementVNode("div", _hoisted_61, [
              (configItem.is_required === 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_62, "*"))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(configItem.type) + "： ", 1)
            ]),
            _createElementVNode("div", _hoisted_63, [
              _createVNode(_component_el_upload, {
                name: "iFile",
                headers: { 'Access-Token': _ctx.token },
                "file-list": configItem.files,
                action: "",
                "before-upload": _ctx.fileLimit,
                "http-request": (file) => _ctx.billFileUpload(file, cIndex),
                onPreview: _ctx.filePreview,
                onRemove: (file) => _ctx.billFileRemove(file, cIndex),
                limit: configItem.max_num,
                "on-exceed": () => _ctx.$message.warning(`最多上传${configItem.max_num}个文件`)
              }, {
                default: _withCtx(() => [
                  (configItem.files.length < configItem.max_num)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_64, _hoisted_67))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["headers", "file-list", "before-upload", "http-request", "onPreview", "onRemove", "limit", "on-exceed"]),
              (configItem.remark)
                ? (_openBlock(), _createElementBlock("p", _hoisted_68, _toDisplayString(configItem.remark), 1))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_69, [
          _hoisted_70,
          _createElementVNode("div", _hoisted_71, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.info.reporterPhone,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.info.reporterPhone) = $event)),
              type: "text",
              style: {"width":"310px"},
              placeholder: "请输入报案人电话"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_72, [
          _createElementVNode("button", {
            class: "btn",
            style: {"width":"200px"},
            onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
          }, " 提 交 "),
          _hoisted_73
        ])
      ])
    ]),
    (_ctx.isAlert)
      ? (_openBlock(), _createBlock(_component_select_personnel, {
          key: 0,
          isRadio: "1",
          onClose: _ctx.close,
          onConfirm: _ctx.confirm
        }, null, 8, ["onClose", "onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.previewFiles.length)
      ? (_openBlock(), _createBlock(_component_el_image_viewer, {
          key: 1,
          "url-list": _ctx.previewFiles,
          "initial-index": _ctx.previewIndex,
          infinite: "",
          onClose: _cache[19] || (_cache[19] = ($event: any) => (_ctx.previewFiles = [])),
          "hide-on-click-modal": ""
        }, null, 8, ["url-list", "initial-index"]))
      : _createCommentVNode("", true)
  ], 64))
}